// extracted by mini-css-extract-plugin
export var body = "_lf-8";
export var button = "_lf-0";
export var closeButton = "_lf-5";
export var content = "_lf-3";
export var empty = "_lf-f";
export var grid = "_lf-c";
export var header = "_lf-4";
export var icon = "_lf-1";
export var option = "_lf-d";
export var optionSelected = "_lf-e";
export var overlay = "_lf-2";
export var searchIcon = "_lf-a";
export var searchInput = "_lf-b";
export var searchWrapper = "_lf-9";
export var title = "_lf-6";
export var visuallyHidden = "_lf-7";